import styles from "./ScrollableComponentTemplate.module.scss";
import useAccessiblePageTitle from "../../../common/page-title/useAccessiblePageTitle.tsx";
import { useRouteMainFocus } from "../utils/useRouteMainFocus.ts";
import BaseHeader from "../../../common/header/BaseHeader.tsx";
import PageTitle from "../../../common/page-title/PageTitle.tsx";
import { ReactNode } from "react";
import ErrorBoundary from "../../../../../common/core-ui/ErrorBoundary.tsx";

export default function ScrollableComponentTemplate({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const accessiblePageTitle = useAccessiblePageTitle(title);

  useRouteMainFocus();

  return (
    <div className={styles.container}>
      <PageTitle title={title} noHeading />
      <BaseHeader noSticky />
      <main className={styles.component} aria-label={accessiblePageTitle}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
    </div>
  );
}
